import React from 'react'
import type { ModalProps } from '@ztechapps/webui.modal'
import { Modal, ModalDragHandle } from '@ztechapps/webui.modal'
import { CreateAndBuild } from './CreateAndBuild'
import type { CreateAndBuildProps } from '@ztechapps/webui.contract'

export type ModalCreateAndBuildProps = CreateAndBuildProps & { modalOptions: ModalProps; modalTitle?: string }

export const ModalCreateAndBuild = ({
  modalOptions,
  afterCreateAndBuild,
  modalTitle,
  ...props
}: ModalCreateAndBuildProps) => {
  return (
    <Modal {...modalOptions}>
      {({ toggleShowModal }) => (
        <>
          <ModalDragHandle>{modalTitle ?? 'Production'}</ModalDragHandle>
          <CreateAndBuild
            {...props}
            afterCreateAndBuild={() => {
              afterCreateAndBuild?.()
              toggleShowModal()
            }}
          />
        </>
      )}
    </Modal>
  )
}
